module.exports = __webpack_public_path__ + "/images/ico-list.09ca03d.svg";